import React from 'react';
import classnames from 'classnames';

const MerlinIcon = ({ className, id='', onClick=()=>{}, pulseOnHover, pulseForever }) => {
  const cssBEM = 'merlin';
  const classes = classnames(cssBEM, className, {
    [`${cssBEM}--pulseOnHover`] : pulseOnHover,
    [`${cssBEM}--pulseForever`] : pulseForever
  });

  return (
    <div className={ classes } id={ id } onClick={onClick}>
      <span className={`${cssBEM}__icon`} />
    </div>
  );
};

export default MerlinIcon;
